import { render, staticRenderFns } from "./CaTester.vue?vue&type=template&id=1bb90d23&"
import script from "./CaTester.vue?vue&type=script&lang=ts&"
export * from "./CaTester.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./CaTester.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports